import { createAction } from '@reduxjs/toolkit';

const setActiveCollectionId = createAction('archive/setActiveCollectionId');

export default setActiveCollectionId;
